import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

import {AdDeliveryOptionResponse} from "@numizmat/services-models/nomenclature";

@Injectable({
  providedIn: 'root'
})
export class AdDeliveryOptionStateService {
  private allAdDeliveryOptions$: BehaviorSubject<AdDeliveryOptionResponse[] | undefined> =
    new BehaviorSubject<AdDeliveryOptionResponse[] | undefined>(undefined);

  public getAllAdDeliveryOptions(): Observable<AdDeliveryOptionResponse[] | undefined> {
    return this.allAdDeliveryOptions$.asObservable();
  }

  public setAllAdDeliveryOptions(allAdDeliveryOptions: AdDeliveryOptionResponse[]): void {
    this.allAdDeliveryOptions$.next(allAdDeliveryOptions);
  }
}
